export const options = {
  line: {
    spanGaps: false,
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 2,
        borderWidth: 1,
        hoverRadius: 2,
        hoverBorderWidth: 1,
      },
      line: {
        tension: 0,
      },
    },
    layout: {
      padding: {
        top: 8,
        left: 8,
        right: 8,
        bottom: 8,
      },
    },
    scales: {
      xAxes: [
        {
          display: false,
        },
      ],
      yAxes: [
        {
          display: false,
          ticks: {
            // min: 100,
            // max: 500
          },
        },
      ],
    },
  },
};
